<div class="row">
  <div class="col-12">
    <span class="secondary-details mr-2" *ngIf="specHeader === 'Create Invoice Specification'">
      {{
        'mapping.specifications.invoiceSpecificationList.addEditInvoiceSpecification.createInvoiceSpecification'
          | translate
      }}
    </span>

    <span class="secondary-details mr-2" *ngIf="specHeader === 'Update Invoice Specification'">
      {{
        'mapping.specifications.invoiceSpecificationList.addEditInvoiceSpecification.updateInvoiceSpecification'
          | translate
      }}
    </span>

    <small class="text-danger text-right">
      {{
        'mapping.specifications.invoiceSpecificationList.addEditInvoiceSpecification.allIndicatedFieldsMandatory'
          | translate
      }}
    </small>
  </div>
</div>

<div class="row mt-2 mb-2" cdkDropListGroup>
  <div class="col-md-4">
    <div class="row">
      <div class="col-12">
        <div [formGroup]="lineItemMappingForm">
          <div class="row" *ngIf="!isSpecEditMode()">
            <div class="col-4">
              <label class="required-field">
                {{
                  'mapping.specifications.invoiceSpecificationList.addEditInvoiceSpecification.specificationName'
                    | translate
                }}</label
              >
            </div>
            <div class="col-8">
              <input
                class="form-control"
                maxlength="52"
                size="52"
                formControlName="specifications_id" />
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-4">
              <label class="required-field">
                {{
                  'mapping.specifications.invoiceSpecificationList.addEditInvoiceSpecification.delimiter'
                    | translate
                }}</label
              >
            </div>
            <div class="col-8 align-items-start">
              <input maxlength="1" size="1" formControlName="delimiter" />
            </div>
          </div>

          <div class="row mt-1">
            <div class="col-4">
              <label class="control-label">
                {{
                  'mapping.specifications.invoiceSpecificationList.addEditInvoiceSpecification.headers'
                    | translate
                }}</label
              >
            </div>
            <div class="col-8 mt-1">
              <mat-checkbox formControlName="headers"></mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <h5 class="ml-2">
      {{
        'mapping.specifications.invoiceSpecificationList.addEditInvoiceSpecification.availableColumns'
          | translate
      }}
    </h5>

    <div class="example-container">
      <div
        style="height: 100vh; overflow-y: auto"
        cdkDropList
        id="cdk1"
        [cdkDropListData]="unMappedFields"
        class="lineItem-list"
        (cdkDropListDropped)="drop($event)">
        <div class="lineItem-box" *ngFor="let item of unMappedFields" cdkDrag>
          {{ item }}
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <h5 class="ml-2">
      {{
        'mapping.specifications.invoiceSpecificationList.addEditInvoiceSpecification.csvFileColumns'
          | translate
      }}
    </h5>
    <div class="example-container">
      <div
        style="height: 100vh; overflow-y: auto"
        cdkDropList
        id="cdk2"
        [cdkDropListData]="mappedFields"
        class="lineItem-list"
        (cdkDropListDropped)="drop($event)">
        <div
          class="lineItem-box"
          *ngFor="let item of mappedFields"
          [ngClass]="{ 'required-field': isFieldMandatory(item) }"
          cdkDrag>
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</div>

<mat-dialog-actions align="end">
  <button class="secondary-btn me-2 text-center" mat-dialog-close="" type="button">
    {{ 'global.close' | translate }}
  </button>
  <button
    class="primary-btn me-2 text-center"
    [disabled]="lineItemMappingForm.pristine"
    (click)="saveLineItemConfigMapping()">
    {{ 'global.save' | translate }}
  </button>
</mat-dialog-actions>
